import React from 'react';
import styled from 'styled-components';
import { Body5, Container } from '@ui';
import { AllCompanySearch } from './AllCompanySearch';
import { StandaloneDocumentSelection } from '../StandaloneDocumentSelection';
import { filterDuplicateCompanies } from '@utils/usefulFuncs';

const Wrapper = styled.div``;
const TickerSelectWrapper = styled.div`
  max-width: 600px;
  margin-top: 24px;
`;
const DocumentSelectionWrapper = styled.div`
  padding: 16px 0 0 0;
`;

export const AllCompanyDocumentSelection = ({
  preSelectedCompanies,
  filters,
  selectedDocs,
  onSelect,
  onRemoveSelect,
}) => {
  const [companies, setCompanies] = React.useState(preSelectedCompanies || []);

  const onAddCompany = (v) => {
    const nextCompanies = filterDuplicateCompanies([...companies, v]);
    setCompanies(nextCompanies);
  };

  return (
    <Wrapper>
      <TickerSelectWrapper>
        <AllCompanySearch onSelect={onAddCompany} />
      </TickerSelectWrapper>
      <DocumentSelectionWrapper>
        {companies.length === 0 ? (
          <Container top={28} left={2}>
            <Body5>Enter and select a company in the search to see a list of all the available documents.</Body5>
          </Container>
        ) : (
          <StandaloneDocumentSelection
            selectedDocs={selectedDocs}
            onSelect={onSelect}
            onRemoveSelect={onRemoveSelect}
            companies={companies}
          />
        )}
      </DocumentSelectionWrapper>
    </Wrapper>
  );
};
